import React from 'react'
import classnames from 'classnames'
import { Navigate, NavLink, Route, Routes } from 'react-router-dom'
import { useAppSelector } from '../../shared/redux/hooks'
import Portfolio from './Portfolio'
import Inbox from './Inbox'
import Cadence from './Cadence'
import Approvals from './Approvals'
import Outbox from './Outbox'
import Reporting from './Reporting'
import InstanceDetail from './InstanceDetail'

// Route-level guard, mirroring Saber.tsx: the nav item is already hidden
// without the permission; this stops direct URL access too.
const CONDUCTOR_READ_PERMISSIONS = ['conductor:read']

const TABS = [
  { label: 'Portfolio', to: '/conductor', end: true },
  { label: 'Inbox', to: '/conductor/inbox', end: false },
  { label: 'Cadence', to: '/conductor/cadence', end: false },
  { label: 'Approvals', to: '/conductor/approvals', end: false },
  { label: 'Outbox', to: '/conductor/outbox', end: false },
  { label: 'Reporting', to: '/conductor/reporting', end: false },
]

const TabBar: React.FC = () => (
  <nav className="flex gap-1 border-b border-slate-200 px-4 pt-3 dark:border-slate-700" aria-label="Conductor">
    {TABS.map((tab) => (
      <NavLink
        key={tab.to}
        to={tab.to}
        end={tab.end}
        className={({ isActive }) =>
          classnames(
            'rounded-t-md px-3 py-2 text-sm font-medium',
            isActive
              ? 'border border-b-0 border-slate-200 bg-white text-slate-900 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100'
              : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
          )
        }
      >
        {tab.label}
      </NavLink>
    ))}
  </nav>
)

export const Conductor: React.FC = () => {
  const { permissions } = useAppSelector((state) => state.app)

  const hasConductor = permissions?.some((p) => CONDUCTOR_READ_PERMISSIONS.includes(p)) ?? false
  if (!hasConductor) {
    return <Navigate to="/" replace />
  }

  return (
    <div>
      <TabBar />
      <Routes>
        <Route index element={<Portfolio />} />
        <Route path="inbox" element={<Inbox />} />
        <Route path="cadence" element={<Cadence />} />
        <Route path="approvals" element={<Approvals />} />
        <Route path="outbox" element={<Outbox />} />
        <Route path="reporting" element={<Reporting />} />
        <Route path="instances/:cuid" element={<InstanceDetail />} />
        <Route path="*" element={<Navigate to="/conductor" replace />} />
      </Routes>
    </div>
  )
}

export default Conductor
